<div class="content-wrapper container-xxl p-0">
  <div class="content-body">
    <app-content-header [contentHeader]="contentHeader"></app-content-header>
    <div class="card">
      <div class="card-title pt-2">
        <div class="row px-1">
          <!--Messaggio con rapportino + utente + stato-->
          <div class="col-12 d-flex align-items-center py-1 px-2">
            <h3 class="m-0" [ngClass.md]="'mr-1'">{{ "WORKDAY_REPORT_OF" | translate }} {{ currentMonthAndYear }}</h3>
            <ng-container [ngSwitch]="statusReport">
              <span [ngClass.sm]="'mt-1'" class="badge badge-info ml-1" *ngSwitchCase="0">{{ "STATUS.GENERATED" | translate }}</span>
              <span [ngClass.sm]="'mt-1'" class="badge badge-success ml-1" *ngSwitchCase="2">{{ "APPROVED" | translate }}</span>
            </ng-container>
          </div>
        </div>
      </div>
      <div class="card-body" *ngIf="myReport">
        <!--header tabella-->
        <div class="row" id="table-header" *ngIf="!_utilService.isMobile && !_utilService.isTablet" #tableHeader>
          <div class="col-xl-2 col-12">
            <h4>{{ "DAYS" | translate | titlecase }}</h4>
          </div>
          <div class="col-xl-2 col-12">
            <h4>{{ "WORKED_HOURS" | translate }}</h4>
          </div>
        </div>
        <!--elenco giorni-->
        <div class="row align-items-center day-row py-2" *ngFor="let day of daysOfTheMonth" [ngClass]="getDayRowClasses(day)" [ngbTooltip]="getDayRowTooltip(day) | translate" placement="top-left" id="day-{{ day }}">
          <div class="col-12">
            <div class="row align-items-center">
              <!--Giorno-->
              <div class="col-xl-2 col-12">
                <div class="d-flex align-items-center">
                  <span>{{ _utilService.formatDate(day, "dddd DD") | titlecase }}</span>
                </div>
              </div>
              <!-- Ore lavorative -->
              <div class="col-xl-2 col-12">
                <input type="number" name="worked-hours" class="form-control" [(ngModel)]="myReport[day].working_hours" (change)="calculateTotalHours()" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="card-footer border-0">
        <div class="row">
          <div class="col-md-6 col-12">
            <!--Conteggio ore totali -->
            <div class="row justify-content-start align-items-start mb-1">
              <div class="col-xl-2 col-12">
                <label for="totalWorkedHours">{{ "WORKED_HOURS" | translate }}:</label>
                <div id="totalWorkedHours">{{ totalWorkedHours }}h</div>
              </div>
            </div>
          </div>
          <div class="col-md-6 col-12">
            <div class="row">
              <!--Tasti visualizzabili soltanto dall'utente-->
              <div class="col-12 d-flex justify-content-end">
                <button class="btn btn-primary" (click)="update()">{{ "SAVE" | translate }}</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
